/* 🤖 this file was generated by svg-to-ts */
export const matIconMotionPhotosPause: {
  name: 'motion-photos-pause';
  data: string;
} = {
  name: 'motion-photos-pause',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m2.88 7.88 1.54 1.54C4.15 10.23 4 11.1 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.9 0-1.77.15-2.58.42L7.89 2.89C9.15 2.32 10.54 2 12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12c0-1.47.32-2.86.88-4.12zM7 5.5C7 6.33 6.33 7 5.5 7S4 6.33 4 5.5 4.67 4 5.5 4 7 4.67 7 5.5zm4 9.5H9V9h2v6zm4 0h-2V9h2v6z"/></svg>`
};
